export const withBusinessGrowth = (
  baseline: number,
  businessGrowth: number,
): number => baseline * (1 + businessGrowth);
